<template>
  <div class="active_table">
    <div class="toolbar">
      <div class="bg_tool">
        <div class="search">
          <i-input prefix="ios-search" placeholder="输入名称查询" v-model="search.name" style="width: auto" />
          <i-button type="default" style="margin-left: 1em;" @click="getData">搜索</i-button>
        </div>
        <div class="active">
          <i-button type="primary" @click="addData">添加</i-button>
          <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
        </div>
      </div>
    </div>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer style="text-align:right;margin-top: 1em" />
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :label-width="100" v-show="modal.title != '权限'">
        <FormItem label="园区名称" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入园区名称"></i-input>
        </FormItem>

        <FormItem label="园区图X">
          <i-input v-model="formValidate.imgUrlMpX" placeholder="输入园区图X坐标"></i-input>
        </FormItem>
        <FormItem label="园区图Y">
          <i-input v-model="formValidate.imgUrlMpY" placeholder="输入园区图Y坐标"></i-input>
        </FormItem>
        <FormItem label="园区图Z">
          <i-input v-model="formValidate.imgUrlMpZ" placeholder="输入园区图Z坐标"></i-input>
        </FormItem>

        <FormItem label="配图：" prop="titlePic">
          <div class="form_upload">
            <LoadImg :imgUrl="formValidate.titlePic" @close="imgLoadDel('titlePic')" @success="imgLoadSuccess($event)">
            </LoadImg>
          </div>
        </FormItem>

        <FormItem label="描述备注" prop="remark">
          <i-input v-model="formValidate.remark" placeholder="输入相关描述"></i-input>
        </FormItem>
      </Form>
      <Form ref="formValidate1" :model="formValidate1" :label-width="100" v-show="modal.title == '权限'">
        <FormItem v-for="(value, key, index) in enumMap.PowerList" :key="index" :label="key">
          <CheckboxGroup v-model="formValidate.permissionArray">
            <Checkbox v-for="item in value" :key="item.code" :label="item.code">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <i-button type="primary" @click="activeData" v-show="modal.title != '权限'">{{ modal.title }}</i-button>
        <i-button type="primary" @click="activePower" v-show="modal.title == '权限'">确定</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>
    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.toolbar {
  width: 100%;
  padding: 3em 1em 1em 1em;
  height: 7.5em;

  .bg_tool {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0.2em 1em;
    border: 1px solid #ccc;
    border-radius: 3.5px;
    justify-content: space-between;
    align-items: center;
  }
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
</style>

<script>
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "园区名称",
            key: "name",
            align: "center"
          },
          {
            title: "描述",
            key: "remark",
            align: "center",
            render(h, params) {
              return h("span", {}, params.row.remark || "暂无");
            }
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h("span", {}, timeStamp(params.row.createDate));
            }
          },
          {
            title: "操作",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "权限";
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        //console.log(params.row.id);
                        this.parkId = params.row.id;
                        this.formValidate = {
                          id: params.row.id,
                          name: params.row.name, // 园区名称
                          titlePic: params.row.titlePic, // 园区大屏标题图片
                          imgUrlMpX: params.row.imgUrlMpX, // 园区大屏地图中心点x
                          imgUrlMpY: params.row.imgUrlMpY, // 园区大屏地图中心点y
                          imgUrlMpZ: params.row.imgUrlMpZ, // 园区大屏地图中心点z
                          remark: params.row.remark, // 备注描述
                          parkId: params.row.id,
                          permissionArray: params.row.permissionArray
                        };
                        this.formValidate.permissionArray = [];
                        this.$api.A_Park.getPower(
                          { content: { parkId: params.row.id } },
                          ["uuid", "system"]
                        ).then(res => {
                          if (res.code == 0) {
                            this.formValidate.permissionArray =
                              res.data.permissionArray;
                            this.modal.show = true;
                          }
                        });
                      }
                    }
                  },
                  "权限"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          name: params.row.name, // 园区名称
                          titlePic: params.row.titlePic, // 园区大屏标题图片
                          imgUrlMpX: params.row.imgUrlMpX, // 园区大屏地图中心点x
                          imgUrlMpY: params.row.imgUrlMpY, // 园区大屏地图中心点y
                          imgUrlMpZ: params.row.imgUrlMpZ, // 园区大屏地图中心点z
                          remark: params.row.remark // 备注描述
                        };
                        this.modal.show = true;
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        name: null
      },
      // 表单
      modal: {
        show: false,
        title: "添加"
      },
      // 权限列表
      enumMap: {
        PowerList: [],
        PowerLoading: true
      },
      // 表单数据
      formValidate: {
        name: "", // 园区名称
        titlePic: null, // 园区大屏标题图片
        imgUrlMpX: "", // 园区大屏地图中心点x
        imgUrlMpY: "", // 园区大屏地图中心点y
        imgUrlMpZ: "", // 园区大屏地图中心点z
        remark: "", // 备注描述
        parkId: "",
        permissionArray: []
      },
      // 验证
      ruleValidate: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        isSystem: [{ required: true, message: "不能为空", trigger: "change" }],
        description: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      formValidate1: {

      },
      parkId: "",
      indeterminate: true,
      checkAll: false,
      checkAllGroup: ["香蕉", "西瓜"],
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      }
    };
  },
  components: {
    LoadImg
  },
  created() {
    this.getData(); // 数据初始化
    this.getPowerList();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        name: "", // 园区名称
        titlePic: null, // 园区大屏标题图片
        imgUrlMpX: "", // 园区大屏地图中心点x
        imgUrlMpY: "", // 园区大屏地图中心点y
        imgUrlMpZ: "", // 园区大屏地图中心点z
        remark: "", // 备注描述
        permissionArray: []
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.A_Park.getParkList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        [null, "system"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.A_Park.delPark({ content: { id: id } }, ["uuids", "system"])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message ? res.message : "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.A_Park.createPark({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.A_Park.modifyPark({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        } else {
        }
      });
    },
    activePower() {
      let params = this.formValidate;
      this.$api.A_Park.postPowerEdit({ content: params }, [
        "uuids",
        "system"
      ]).then(res => {
        if (res.code == 0) {
          this.$Notice.success({
            title: "更新成功",
            desc: "更新成功，正在刷新数据..."
          });
          this.modal.show = false;
          this.getData();
        } else {
          this.$Notice.warning({
            title: "更新失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // img删除回调
    imgLoadDel(data) {
      this.formValidate[data] = null;
    },
    // img上传组件回调
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.titlePic = url;
    },
    //获取权限列表
    getPowerList() {
      // 获取权限列表
      this.enumMap.PowerLoading = true;
      this.$api.A_Park.getPowerList(null, ["uuids", "system"]).then(res => {
        // console.log(res)
        if (res.code == 0) {
          // 请求成功
          this.enumMap.PowerList = res.data;
          this.enumMap.PowerLoading = false;
        } else {
          this.$Message.warning(res.message);
          this.enumMap.PowerLoading = false;
        }
      });
    },
  }
};
</script>